<script setup>
/** 一场分镜提交过的每一次供应商调用，按时间顺序。 */
import { Badge } from '@drama/ui'
import { useI18n } from 'vue-i18n'

import { formatDate, formatDuration } from '../generation-records-format.js'
import { callVariant } from './segment-stage.js'

defineProps({
  calls: { type: Array, required: true },
})

const { t } = useI18n()

function promptLength(prompt) {
  return t('visualGameAdmin.generationRecords.process.scene.promptChars', { count: [...prompt].length })
}
</script>

<template>
  <ol v-if="calls.length > 0" class="scene-calls">
    <li v-for="(call, index) in calls" :key="call.id" class="scene-calls__item">
      <div class="scene-calls__row">
        <span class="scene-calls__no">#{{ index + 1 }}</span>
        <span>{{ formatDate(call.created_at) }}</span>
        <Badge :variant="callVariant(call.status)" size="sm">{{ t(`visualGameAdmin.generationRecords.process.scene.call.${call.status}`) }}</Badge>
        <span>{{ formatDuration(call.duration_ms) }}</span>
        <code v-if="call.provider_task_id">{{ call.provider_task_id }}</code>
        <span v-if="call.charged_points">{{ t('visualGameAdmin.generationRecords.process.scene.points', { count: call.charged_points }) }}</span>
      </div>
      <p v-if="call.error_reason" class="scene-calls__error">{{ call.error_reason }}</p>
      <details v-if="call.prompt" class="scene-calls__prompt">
        <summary>{{ t('visualGameAdmin.generationRecords.process.scene.callPrompt') }} · {{ promptLength(call.prompt) }}</summary>
        <pre>{{ call.prompt }}</pre>
      </details>
    </li>
  </ol>
  <p v-else class="scene-calls__empty">{{ t('visualGameAdmin.generationRecords.process.scene.noCalls') }}</p>
</template>

<style scoped>
.scene-calls {
  display: flex;
  flex-direction: column;
  gap: var(--drama-space-sm);
  margin: 0;
  padding: 0;
  list-style: none;
}

.scene-calls__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--drama-space-sm);
  font-size: var(--drama-font-size-xs);
}

.scene-calls__row code {
  font-family: var(--drama-font-family-mono);
}

.scene-calls__no {
  color: var(--drama-color-text-muted);
  font-family: var(--drama-font-family-mono);
}

.scene-calls__error {
  margin: var(--drama-space-xs) 0 0;
  color: var(--drama-color-danger);
  font-size: var(--drama-font-size-xs);
  word-break: break-word;
}

.scene-calls__prompt summary {
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
  cursor: pointer;
}

.scene-calls__prompt pre {
  margin: var(--drama-space-sm) 0 0;
  padding: var(--drama-space-md);
  overflow: auto;
  max-height: 480px;
  border: 1px solid var(--drama-color-border);
  border-radius: var(--drama-radius-sm);
  background: var(--drama-color-bg);
  font-family: var(--drama-font-family-mono);
  font-size: var(--drama-font-size-xs);
  white-space: pre-wrap;
}

.scene-calls__empty {
  margin: 0;
  color: var(--drama-color-text-muted);
  font-size: var(--drama-font-size-xs);
}
</style>
